export const positionsUpdate = (target, scrollY) => ({
  type: 'POSITIONS_UPDATE',
  target,
  scrollY,
});
